import options from './chart-motion.component';

export default {
    selector: 'dtChartMotion',
    options
};
